import { render, staticRenderFns } from "./C2ChatWidget.vue?vue&type=template&id=564bfef8&scoped=true"
import script from "./C2ChatWidget.vue?vue&type=script&lang=js"
export * from "./C2ChatWidget.vue?vue&type=script&lang=js"
import style0 from "./C2ChatWidget.vue?vue&type=style&index=0&id=564bfef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564bfef8",
  null
  
)

export default component.exports